/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table-atividade[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:right;background-color:#eee;width:30%;border:#bbb!important}.table-atividade[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{text-align:left}"];
export { styles as styles };
